import classNames from "classnames";
import * as React from "react";
import { FC, useEffect, useState } from "react";
import * as styles from "./Loading.less";
import { useFirstTimeLoad } from "./useFirstTimeLoad";

export enum LoadingTheme {
    big = "big",
    bird = "bird",
    christmas_bird = "christmas_bird",
    medium = "medium",
    chips = "chips",
    select = "select",
}
const showLoadingDelay = 200;

export interface LoadingProps {
    theme?: LoadingTheme;
    /**
     * set this flag for centring loading inside window
     */
    fixed?: boolean;
    /**
     * set this flag for centering loading inside relative parent
     */
    absolute?: boolean;
    withDelay?: boolean;
    className?: string;
    /**
     * set this flag for loader that need paddings in 16px
     */
    withPaddings?: boolean;
    dataTestId?: string;
}

export const Loading: FC<LoadingProps> = ({ theme, fixed, absolute, withDelay, className, withPaddings }) => {
    const wrapperClass = classNames(
        styles.wrapper,
        fixed && styles.fixed,
        absolute && styles.absolute,
        withPaddings && styles.with_paddings,
        className
    );

    let showBird = useFirstTimeLoad();

    if (theme === LoadingTheme.big && showBird) {
        theme = isChristmasTime() ? LoadingTheme.christmas_bird : LoadingTheme.bird;
    }

    const loadingContent = <div className={classNames(styles.spinner, styles[theme])} />;

    const [content, setContent] = useState(withDelay ? null : loadingContent);

    useEffect(() => {
        if (withDelay) {
            const timer = setTimeout(() => {
                setContent(loadingContent);
            }, showLoadingDelay);
            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <div role="status" className={wrapperClass} aria-label="loading">
            {content}
        </div>
    );
};

const isChristmasTime = () => {
    const now = new Date();
    // December 15 - January 5
    return (now.getMonth() === 11 && now.getDate() >= 15) || (now.getMonth() === 0 && now.getDate() <= 5);
};

export default Loading;
